import { ScheduleEntry } from '../../../clients/quipli-service/availability/availability';
import { NotInServiceScheduleTooltip } from './not-in-service-tooltip';
import { OrderScheduleTooltip } from './order-tooltip';
import { SoldTooltip } from './sold-tooltip';
import { WorkOrderTooltip } from './work-order-tooltip';

export const ScheduleTooltip = ({ scheduleEntry }: { scheduleEntry: ScheduleEntry }) => {
  switch (scheduleEntry.type) {
    case 'WorkOrder':
      return <WorkOrderTooltip workOrderScheduleEntry={scheduleEntry} />;
    case 'Sold':
      return <SoldTooltip soldScheduleEntry={scheduleEntry} />;
    case 'Order':
      return <OrderScheduleTooltip orderScheduleEntry={scheduleEntry} />;
    case 'NotInService':
      return <NotInServiceScheduleTooltip notInServiceScheduleEntry={scheduleEntry} />;
  }
};
